import type { ApolloCache } from '@apollo/client';

import { useQuery } from 'src/modules/apollo';
import { getDataFromCache } from 'src/modules/apollo/apolloCache';
import * as Schema from 'src/types/graphql';

export const useCandidateId = () => {
  const { data, loading, error } = useQuery(Schema.GetIdDocument);

  const candidateId = loading || error ? null : data?.viewer?._id || null;

  return { candidateId, loading, error };
};

export const getCandidateIdFromCache = <T extends Record<string, any>>(
  cache: ApolloCache<T>,
): Schema.Maybe<string> => {
  const data = getDataFromCache({ cache, query: Schema.GetIdDocument });
  const _id = data?.viewer?._id || null;

  return _id;
};

/** Returns a mock response for use with the apollo MockedProvider */
export const mockGetIdRequest = (_id: string = '1234') => ({
  request: {
    query: Schema.GetIdDocument,
  },
  result: {
    data: {
      viewer: {
        _id,
      },
    },
  },
});
